import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {HttpClient} from '@angular/common/http';
import {ForgotPasswordApiData, ForgotPasswordReqObj, LoginApiData, LoginReqObj} from '../auth/autentication-http-interfaces';

const RESERVATIONS_API_ROUTES = {
  GET_RESERVATION_COMPANIES: 'admin/reservation-companies',
  GET_SINGLE_RESERVATION_COMPANY: 'admin/reservation-companies/:reservationId',
  GET_RESERVATION_GIFTS: 'admin/reservation-gifts',
  GET_RESERVATION_DELIVERY: 'admin/reservation-deliveries',
  GET_EXPORT_RESERVATIONS_PDF: 'admin/reservation-companies/export-pdf',
  GET_EXPORT_RESERVATIONS_EXCEL: 'admin/reservation-companies/export-excel',
  GET_EXPORT_BOUGHT_GIFTS_PDF: 'admin/reservation-gifts-export-pdf',
  GET_EXPORT_BOUGHT_GIFTS_EXCEL: 'admin/reservation-gifts-export-excel',
  GET_EXPORT_DELIVERY_EXCEL: 'admin/reservation-deliveries-export-excel',
  GET_EXPORT_WISHLIST_EXCEL: 'admin/reservation-companies/:reservationId/export-gift-wishlist-excel',
  GET_EXPORT_WISHLIST_PDF: 'admin/reservation-companies/:reservationId/export-gift-wishlist-pdf',
  POST_GIFTS_REFUND: 'admin/gift/defiscalization',
  GET_EXPORT_DASHBOARD_DATA: 'admin/export-company-reservations',
};
@Injectable({
  providedIn: 'root'
})
export class ReservationsHttpService {

  constructor(private generalHttpHelperService: GeneralHttpHelperService,
              private httpClient: HttpClient) { }

  getExportReservationsPdf(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_RESERVATIONS_PDF, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportReservationsExcel(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_RESERVATIONS_EXCEL, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportBoughtGiftsPdf(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_BOUGHT_GIFTS_PDF, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportBoughtGiftsExcel(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_BOUGHT_GIFTS_EXCEL, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportOrdersExcel(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_DELIVERY_EXCEL, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportWishlistPdf(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(RESERVATIONS_API_ROUTES.GET_EXPORT_WISHLIST_PDF, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  getExportWishlistExcel(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(RESERVATIONS_API_ROUTES.GET_EXPORT_WISHLIST_EXCEL, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }

  private getReservationsCompaniesReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_RESERVATION_COMPANIES, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getReservationsCompanies(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getReservationsCompaniesReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getSingleReservationReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(RESERVATIONS_API_ROUTES.GET_SINGLE_RESERVATION_COMPANY, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getSingleReservation(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getSingleReservationReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getReservationsGiftsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_RESERVATION_GIFTS, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getReservationsGifts(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getReservationsGiftsReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getNotificaitonsUnreadCOuntGiftsReq(): Observable<any> {
    return this.httpClient.get('admin/notifications-gifts') as any;
  }
  getNotificaitonsUnreadCOuntGifts(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getNotificaitonsUnreadCOuntGiftsReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getNotificaitonsUnreadCOuntReservtionsReq(): Observable<any> {
    return this.httpClient.get('admin/notifications-reservations') as any;
  }
  getNotificaitonsUnreadCOuntReservtions(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getNotificaitonsUnreadCOuntReservtionsReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getSidemenuNotificaitonsUnreadCOuntReservtionsReq(): Observable<any> {
    return this.httpClient.get('admin/notifications-reservations-gifts') as any;
  }
  getSidemenuNotificaitonsUnreadCOuntReservtions(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getSidemenuNotificaitonsUnreadCOuntReservtionsReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }


  private getOrdersReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_RESERVATION_DELIVERY, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getOrders(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getOrdersReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private postRefundGiftsReq(bodyParams: any): Observable<any> {
    return this.httpClient.post(RESERVATIONS_API_ROUTES.POST_GIFTS_REFUND, bodyParams) as any;
  }

  postRefundGifts(bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postRefundGiftsReq(bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  exportDashboardData(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(RESERVATIONS_API_ROUTES.GET_EXPORT_DASHBOARD_DATA, urlParams);
    return this.httpClient.get(apiUrl, { responseType: 'blob' });
  }
}
